import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { CookieConsentProvider } from "./CookieConsent";
import { AuthProvider } from "./AuthContext";
import AskIrene from "./AskIrene";

Sentry.init({
  dsn: "https://c99470b6775ab9d23f91f2b0f3fbaee0@o4511124015022080.ingest.us.sentry.io/4511124020789248",
  sendDefaultPii: false,
  environment: process.env.NODE_ENV,
  // Only send errors in production — suppress noise during local dev
  enabled: process.env.NODE_ENV === "production",
  integrations: [Sentry.browserTracingIntegration()],
  // Capture 10% of sessions for performance traces; 100% of errors always captured
  tracesSampleRate: 0.1,
});

const SentryErrorFallback = ({ error, resetError }) => (
  <div style={{
    minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
    fontFamily: "'Karla', sans-serif", padding: "24px", backgroundColor: "#fafaf8",
  }}>
    <div style={{ maxWidth: "480px", textAlign: "center" }}>
      <p style={{
        fontFamily: "'DM Serif Display', serif",
        fontSize: "28px", color: "#1a1a1a", marginBottom: "12px",
      }}>Something went wrong</p>
      <p style={{ fontSize: "15px", color: "#6e6e6e", lineHeight: 1.7, marginBottom: "28px" }}>
        An unexpected error occurred. Our team has been notified. Try refreshing the page.
      </p>
      <button
        onClick={resetError}
        style={{
          padding: "12px 28px", fontSize: "14px", fontWeight: "500",
          backgroundColor: "#2d5a3d", color: "#fff",
          border: "none", borderRadius: "8px", cursor: "pointer",
          fontFamily: "inherit",
        }}
      >
        Try again
      </button>
    </div>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={SentryErrorFallback} showDialog={false}>
      <CookieConsentProvider>
        <AuthProvider>
          <AskIrene />
        </AuthProvider>
      </CookieConsentProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
